import MuiAlert from './MuiAlert';
import MuiAutocomplete from './MuiAutocomplete';
import MuiButton from './MuiButton';
import MuiCheckbox from './MuiCheckbox';
import MuiChip from './MuiChip';
import MuiFilledInput from './MuiFilledInput';
import MuiInputLabel from './MuiInputLabel';
import MuiLink from './MuiLink';
import MuiRadio from './MuiRadio';
import MuiRating from './MuiRating';
import MuiSelect from './MuiSelect';
import MuiStepLabel from './MuiStepLabel';
import MuiTextField from './MuiTextField';
import MuiTooltip from './MuiTooltip';
const props = {
  MuiAlert,
  MuiAutocomplete,
  MuiButton,
  MuiCheckbox,
  MuiChip,
  MuiFilledInput,
  MuiInputLabel,
  MuiLink,
  MuiRadio,
  MuiRating,
  MuiSelect,
  MuiStepLabel,
  MuiTextField,
  MuiTooltip
};
export default props;